import React, {useState} from 'react';
import {
  Box,
  Button,
  TextField,
  Typography,
  Paper,
} from '@mui/material';
import imgUrl from '../assets/images/imgUrl';
import { useNavigate } from "react-router";

const ActivateAccount = () => {
  const [email, setEmail] = useState('');
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        overflow:"hidden"
      }}
      className="LoginSection"
    >
      <Paper elevation={5} sx={{ p: 4, width: 360, textAlign: 'center', borderRadius: 2 }} className='UserSubSection'>
        {/* Logo */}
        <Box sx={{ mb: 2 }}>
          <img src={imgUrl.peaceMovImg} alt="Logo" width="100" /> {/* Replace with your logo path */}
        </Box>

        {/* Heading */}
        <Typography variant="h6" fontWeight="400" mb={0} className='loginHeading'>
          Activate Account
        </Typography>
        <Typography variant="body2" color="text.secondary" mb={4}>
          Activate Account for peacekeeper only
        </Typography>

      <Typography sx={{textAlign:"left"}}>Email Address</Typography>
        {/* Email Input */}
        <TextField
          fullWidth
          label=""
          placeholder='Please enter email'
          type="email"
          required
          variant="outlined"
          margin="dense"
          size="small"
          sx={{mb:2}}
          onChange={(e) => setEmail(e.target.value)}
        />
         

       

        {/* Activate Button */}
        <Button
          fullWidth
          variant="contained"
          sx={{
            mt: 2,
            background: 'linear-gradient(to right, #214F7D, #3A8139)',
            color: 'white',
            borderRadius:"50px"
          }}
          onClick={() => navigate("/setuppassword")}
          
        >
          Activate
        </Button>

       
      </Paper>
    </Box>
  );
};

export default ActivateAccount;
